/**
 * 已确认菜单的历史记录（localStorage）
 */
const STORAGE_KEY = 'foodtoge_menu_history'

function loadAll() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

function saveAll(list) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list || []))
}

export function listMenuHistory() {
  return loadAll().slice().sort((a, b) => {
    const pa = Number(a.perCapita) || 0
    const pb = Number(b.perCapita) || 0
    if (pa !== pb) return pa - pb
    return (Number(a.guestCount) || 0) - (Number(b.guestCount) || 0)
  })
}

export function getMenuHistory(id) {
  return loadAll().find((item) => String(item.id) === String(id)) || null
}

/**
 * 确认菜单时写入一条历史：标题与 PDF 一致（订餐日期 + 包厢名），正文为竖排菜名
 */
export function addMenuHistory(payload) {
  const item = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    createdAt: Date.now(),
    orderDate: payload.orderDate || '',
    roomName: payload.roomName || '',
    perCapita: Number(payload.perCapita) || 0,
    guestCount: Number(payload.guestCount) || 0,
    dishNames: Array.isArray(payload.dishNames) ? payload.dishNames.slice() : [],
    dishes: Array.isArray(payload.dishes)
      ? payload.dishes.map((d) => ({
        id: d.id,
        name: d.name,
        price: Number(d.price),
        cost: Number(d.cost),
        category: d.category
      }))
      : [],
    profitRatePercent: payload.profitRatePercent || '',
    needWei: payload.needWei === true,
    title: payload.title
      || `${payload.orderDate || ''} ${payload.roomName || ''}`.trim(),
    previewContent: payload.previewContent != null ? String(payload.previewContent) : ''
  }
  const list = loadAll()
  const sameIndex = list.findIndex((row) => (
    Number(row.perCapita) === item.perCapita && Number(row.guestCount) === item.guestCount
  ))
  if (sameIndex >= 0) {
    item.id = list[sameIndex].id
    list.splice(sameIndex, 1, item)
  } else {
    list.unshift(item)
  }
  saveAll(list)
  return item
}
